import DatePopupSelector from "../../../../../../../common/Inputs/Calendar/DatePopupSelector/DatePopupSelector";
import DatePeriodControlled from "../../../../../../../common/Inputs/DatePeriodControlled/DatePeriodControlled";
import CommentInput from "../../../../../../../common/Inputs/CommentInput/CommentInput";
import CustomUploader from "../../../../../../../common/CustomUploader/CustomUploader";


import { v4 as uuidv4 } from "uuid";

import { useSelector } from "react-redux";
import React from "react";
import moment from "moment/moment";

const BloodDonation = ({
    currentRequest,
    changeDateHandler,
    setRequestState,
    referenceHandler,
    commentHandler,
}) => {
    const isUserAttachmentsAllowed = useSelector(state => state.requests.isUserAttachmentsAllowed);
    return (
        <>
            <DatePopupSelector
                field={"donationDate"}
                label={<>Дата сдачи крови <span className="required_text"> *</span></>}
                errorMessage={
                    currentRequest
                    && currentRequest.isValid
                    && currentRequest.isValid.bloodDonationData
                    && currentRequest.isValid.bloodDonationData.donationDate
                        ? ""
                        : "Обязательное поле"
                }
                changeHandler={changeDateHandler}
                propsDate={
                    currentRequest
                    && currentRequest.bloodDonationData
                    && currentRequest.bloodDonationData.donationDate
                }
                minDate={new Date(moment().subtract(1, "years").toDate())}
                maxDate={new Date()}
            />
            {currentRequest &&
                currentRequest.periods &&
                currentRequest.periods.map((period, index) => {
                    return (
                        <DatePeriodControlled
                            allowsMultipleDateRanges={true}
                            setRequestState={setRequestState}
                            periodsLength={
                                currentRequest
                                && currentRequest.periods
                                && currentRequest.periods.length
                                    ? currentRequest.periods.length
                                    : false
                            }
                            key={uuidv4()}
                            parentStyle={"postpone-vacation"}
                            period={period}
                            index={index}
                            datesForRange={{
                                minFrom: new Date(),
                                // minTo: new Da ,
                            }}
                            label={
                                {
                                    from: <>Дата начала отдыха <span className="required_text"> *</span></>,
                                    to: <>Дата окончания отдыха <span className="required_text"> *</span></>,
                                }
                            }
                        />
                    );
                })
            }
            <CommentInput
                value={
                    currentRequest
                    && currentRequest.bloodDonationData
                    && currentRequest.bloodDonationData.certificateNumber
                }
                basicInput={true}
                maxLength={50}
                stateProperty={"attachmentDocumentsCodes"}
                changeHandler={referenceHandler}
                label={<>Номер справки о сдаче крови и ее компонентов <span
                    className="required_text"> *</span></>}
                errorMessage={
                    currentRequest
                    && currentRequest.isValid
                    && currentRequest.isValid.bloodDonationData
                    && currentRequest.isValid.bloodDonationData.certificateNumber
                        ? ""
                        : "Обязательное поле"
                }
                parentStyle={"extra-vacation-days"} />
            <CommentInput
                maxLength={255}
                value={currentRequest && currentRequest.employeeComment}
                stateProperty={"employeeComment"}
                changeHandler={commentHandler}
                label={"Комментарий"}
                parentStyle={"unplanned-vacation"}
            />
            {
                isUserAttachmentsAllowed  &&   currentRequest &&
            currentRequest.periods &&
            currentRequest.periods.length &&
            currentRequest.periods[0].dateFrom && currentRequest.periods[0].dateTo ?
                    <CustomUploader /> : null
            }

        </>
    );
};

export default BloodDonation;
